package com.milta.core.localization.translations.es

import com.milta.core.localization.UnlocatedDeliveryStrings

internal val UnlocatedDelivery = UnlocatedDeliveryStrings(
    warningTitleSingular = "1 dirección no localizada",
    warningTitlePlural = "%d direcciones no localizadas",
    warningMessage = "Estas entregas no se pudieron situar en el mapa. Corrija su dirección o continúe: se colocarán al final de la ruta.",
    fixAction = "Corregir",
    continueWithoutAction = "Continuar sin ellas",
    unplacedStopsSingular = "1 parada no situada, al final de la ruta",
    unplacedStopsPlural = "%d paradas no situadas, al final de la ruta",
    fixAddressAction = "Corregir la dirección",
    unlocatedBadge = "No localizada",
)
